import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import Splash from '../common/Splash';

function HotGame({slidersFeatures}) {

  const [isLoading, setIsLoading] = useState(false);
      const [isLoggedIn] = useState(!!localStorage.getItem('token'));
      const navigate = useNavigate();
      const [error, setError] = useState(null);
      const origin = window.location.origin;
    const handleGameClick = async (gameCode) => {
        if(!isLoggedIn) {
          navigate('/login');
          return;
        }
        if (typeof gameCode === 'string' && gameCode.startsWith('http')) {
          navigate('/gamerun', { state: { iframeUrl: gameCode } });
          return;
        }
        setIsLoading(true);
  
          try {
              const token = localStorage.getItem('token');
              const remote_id = localStorage.getItem('remote_id');
              if (!token || !remote_id) {
                  setError('User not logged in');
                  return;
              }
              let platform = undefined;
              let gameType = undefined;
              if (typeof gameCode === 'string' && gameCode.includes('-')) {
                const parts = gameCode.split('-');
                if (parts.length >= 2) {
                  platform = parts[0];
                  gameType = parts[1];
                }
              }
                 
            
              const response = await fetch(`${process.env.REACT_APP_API_URL}/api/inr-game-run`, {
                  method: 'POST',
                  headers: {
                      'Accept': 'application/json',
                      'Content-Type': 'application/json',
                      'Authorization': `Bearer ${token}`,
                  },
                 
                  body: JSON.stringify({
                     userId : remote_id,
                     externalURL: origin,
                     isMobileLogin: window.innerWidth <= 768,
                     gameCode: gameCode,
                     gameType: gameType,
                     platform: platform
                     
                     
                  }),
                 
              });
  
              const data = await response.json();
              if (response.ok) {
                  const iframeUrl = data?.url || data?.data?.payload?.game_launch_url;
                  if (iframeUrl) {
                    navigate('/gamerun', { state: { iframeUrl } });
                  } else {
                    setError(data.message || 'Missing game URL in response');
                  }
              } else {
                  setError(data.message || 'An unexpected error occurred');
              }
          } catch (error) {
              setError('An unexpected error occurred');
          }
          finally {
              setIsLoading(false);
          }
      };
      if(isLoading) {
        return(
         <Splash onSplashComplete={() => {
           setIsLoading(false);
           setTimeout(() => {
             window.dispatchEvent(new Event('resize'));
           }, 100);
         }}/>
        );
      }
  return (
   <div className="row mt-0 hidden-md-and-up mobile-provider-card-row left-right-gap">
    {slidersFeatures.map((feature, index) => (
  <div key={index} onClick={() => handleGameClick(feature.link)} className="mobile-provider-card-item col gT_homepageHot">
    <div className="v-image v-responsive banner-img theme--dark homepageHot_img">
      <div className="v-responsive__sizer" style={{paddingBottom: '100%'}} />
      <div className="v-image__image v-image__image--cover" style={{backgroundImage: `url(${process.env.REACT_APP_API_URL}/storage/${feature.thubmnail})`, backgroundPosition: 'center center'}} />
      <div className="v-responsive__content">
        {/**/}
        <img src="./static/image/other/hot-icon.png" className="img-hot-home pos_right_top" />
      </div>
    </div>
  </div>
  ))}
  
  


  <div id="autoFillEle1" className="mobile-provider-card-item gT_homepageHot" style={{maxHeight: '0px !important'}}>
    <div className="v-image v-responsive banner-img theme--dark" style={{maxHeight: '0px'}}>
      <div className="v-image__image v-image__image--preload v-image__image--cover" style={{backgroundPosition: 'center center'}} />
      <div className="v-responsive__content" />
    </div>
  </div>
  <div id="autoFillEle2" className="mobile-provider-card-item gT_homepageHot" style={{maxHeight: '0px !important'}}>
    <div className="v-image v-responsive banner-img theme--dark" style={{maxHeight: '0px'}}>
      <div className="v-image__image v-image__image--preload v-image__image--cover" style={{backgroundPosition: 'center center'}} />
      <div className="v-responsive__content" />
    </div>
  </div>
</div>

  );
}

export default HotGame;